import { useEffect, useRef } from 'react';
import { useAuthUser } from './useAuthUser';
import { usePlayerProfile } from './usePlayerProfile';

// Single source of truth for "is this session an upgrade-eligible guest" —
// consumed independently by the persistent nav badge (AnonUpgradeBadge) and
// the post-tournament auto-prompt trigger (Tournament.js), so "anonymous"
// and "first tournament" never drift between the two.
//
// isFirstTournamentEligible mirrors myProfile right up until the caller
// passes freezeEligibility (Tournament.js does this the instant *this
// player's own* participation ends — win or elimination — regardless of
// whether the rest of the bracket has finished), then stops updating so a
// tournament can't erase its own "first tournament" signal by writing
// tournamentsPlayed before this hook re-reads it.
export function useAnonymousUpgradePrompt({ freezeEligibility = false } = {}) {
  const authUser = useAuthUser();
  const myProfile = usePlayerProfile(authUser?.uid);
  const eligibleRef = useRef(true);

  useEffect(() => {
    if (freezeEligibility) return;
    eligibleRef.current = !myProfile || !myProfile.tournamentsPlayed;
  }, [myProfile, freezeEligibility]);

  return {
    authUser,
    myProfile,
    isAnonymous: !!authUser?.isAnonymous,
    isFirstTournamentEligible: eligibleRef.current,
  };
}
